import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImport: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconImport"><Path d="M2 4V5.5H7C9.34721 5.5 11.25 7.40279 11.25 9.75V13.1893L8.25 10.1893L7.18934 11.25L12 16.0607L16.8107 11.25L15.75 10.1893L12.75 13.1893V9.75C12.75 6.57436 10.1756 4 7 4H2Z" fill="currentColor"/><Path d="M15 4V5.5H20.5V18.5H3.5V8H2V20H22V4H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImport;
